import { render, staticRenderFns } from "./RxCheckBox.vue?vue&type=template&id=c15bec64"
import script from "./RxCheckBox.vue?vue&type=script&lang=js"
export * from "./RxCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports